<div class="container">
  <ds-mirador-viewer
    id="iiif-viewer"
    [object]="item"
    [searchable]="isSearchable"
    [query]="query$ | async"
  ></ds-mirador-viewer>
</div>
